import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme) => ({
  image_video: {
    minWidth: "550px",
    maxWidth: "550px",
    maxHeight: "600px",
    objectFit: "cover",
    [theme.breakpoints.down("md")]: {
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "600px",
    },
  },

  loader: {
    position: "absolute",
    width: "552px",
    height: "300px",
    background: "#13082A",
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "600px",
    },
  },
}));
